// Contexte d'affichage de la PWA : appli installée ou onglet de navigateur, et plateforme.

export const isStandalone = () =>
  window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

export const isIOS = () =>
  (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
  !window.MSStream;

// La PWA est réservée au téléphone. Chrome et Edge l'indiquent directement ; sinon, un
// écran tactile dont le petit côté reste sous 600 px distingue le téléphone de la
// tablette et de l'ordinateur.
export const isPhone = () => {
  if (navigator.userAgentData?.mobile === true) return true;
  const coarse = window.matchMedia('(pointer: coarse)').matches;
  return coarse && Math.min(window.screen.width, window.screen.height) < 600;
};

// Sur iPhone, seul Safari sait installer l'application. Les autres navigateurs et les
// navigateurs intégrés aux applis (Gmail, Slack, WhatsApp, Facebook…) s'en distinguent par
// un jeton propre ou par l'absence du jeton « Safari/ » dans le user agent.
const IOS_NOT_SAFARI =
  /CriOS|FxiOS|EdgiOS|OPiOS|OPT\/|YaBrowser|Ddg\/|GSA\/|FBAN|FBAV|Instagram|LinkedInApp|Line\/|Snapchat|Twitter|Pinterest|WhatsApp|Slack/;

export const isIOSSafari = (ua = navigator.userAgent) => /Safari\//.test(ua) && !IOS_NOT_SAFARI.test(ua);

// Chrome sur Android (et non Samsung Internet, Edge, Firefox…), d'après les marques déclarées.
export const isChromeAndroid = (uaData = navigator.userAgentData) =>
  uaData?.mobile === true && (uaData.brands || []).some(({brand}) => brand === 'Google Chrome');
